
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import Spinner from '@/components/common/Spinner.vue';
  import MultiselectTag from "@/components/autocompleteMultiselects/MultiselectTag.vue";
  import DropdownOption from "@/entities/DropdownOption";
  import DropdownGroupOption from "@/entities/DropdownGroupOption";

  @Component({
    components: {
      MultiselectTag,
      Spinner
    }
  })
  export default class FormAsyncselect extends Vue {
    @Prop({ type: String, default: "" }) readonly title!: string;
    @Prop({ type: String, default: "" }) readonly type!: string;
    @Prop({ type: String, default: "" }) readonly placeholder!: string;
    @Prop({ type: Array, default: () => [] }) readonly value!: DropdownOption[] | DropdownGroupOption[];
    @Prop({ type: Array, default: () => [] }) readonly options!: any[];
    @Prop({ type: String, default: "" }) readonly selectLabel!: string;
    @Prop({ type: String, default: "" }) readonly deselectLabel!: string;
    @Prop({ type: String, default: "List is empty" }) readonly noOptionsText?: string;
    @Prop({ type: String, default: "Nothing matches the query" }) readonly noResultsText?: string;
    @Prop({ type: Boolean, default: true }) readonly closeOnSelect!: boolean;
    @Prop({ type: Boolean, default: true }) readonly multiple!: boolean;
    @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
    @Prop({ type: Boolean, default: true }) readonly searchable!: boolean;
    @Prop({ type: Boolean, default: false }) readonly showNoResults!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
    @Prop({ type: Number, default: undefined }) readonly max?: number;
    @Prop({ type: String, default: "name" }) readonly trackBy!: string;
    @Prop({ type: String, default: undefined }) readonly groupLabel?: string;
    @Prop({ type: String, default: undefined }) readonly groupValues?: string;
    @Prop({ type: Boolean, default: false }) readonly groupSelect!: boolean;

    selectedItems: any = null;

    isLoading = false;

    get tagMaxWidth(): object {
      return { "max-width": "85%" };
    }

    get classObject (): object {
      return {
        "error" : this.invalid,
      };
    }

    @Watch("value", {immediate: true})
    onValueChange() {
      this.selectedItems = this.multiple ? this.value : this.value[0];
    }

    asyncFind(query: string) {
      this.$emit("search", query);
    }

    customLabel(props: any): string {
      if (props.user) {
        return this.userLabel(props.user);
      } else {
        return this.itemLabel(props);
      }
    }

    userLabel(user: any): string {
      return `${user.givenName} ${user.familyName}`;
    }

    itemLabel(item: any): string {
      return item.name;
    }

    addTag(tag: any): void {
      this.options.push(tag);
      this.selectedItems.push(tag);
    }

    update(newVal: any): void {
      if (this.multiple) {
        this.$emit("input", newVal);
      } else {
        this.$emit("input", newVal !== null ? [newVal] : []);
      }
    }
  }
